import { render, staticRenderFns } from "./recorder.vue.js?vue&type=template&id=6b441884!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recorder.vue?vue&type=template&id=6b441884"
import script from "./recorder.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recorder.vue?vue&type=script&lang=js"
export * from "./recorder.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recorder.vue?vue&type=script&lang=js"
import style0 from "./recorder.vue.scss?vue&type=style&index=0&id=6b441884&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recorder.vue?vue&type=style&index=0&id=6b441884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports